// // //
// IMPORTED FILE ----------✅✅✅
// // //
// GLOBAL VARIABLE ----------✅✅✅
const $977499bb1a4cda90$var$SUITS = [
    "\u2660",
    "\u2663",
    "\u2665",
    "\u2666"
];
const $977499bb1a4cda90$var$VALUES = [
    "A",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "J",
    "Q",
    "K"
];
class $977499bb1a4cda90$export$2e2bcd8739ae039 {
    constructor(cards = $977499bb1a4cda90$var$freshDeck()){
        this.cards = cards;
    // console.log(cards);
    }
    get numberOfCards() {
        return this.cards.length;
    }
    pop() {
        return this.cards.shift();
    }
    push(card) {
        this.cards.push(card);
    }
    // ⏺ (Fisher-Yates Shuffle) Algorithm
    // i > 0 ensures the loop only swaps cards when there are two or more cards to swap
    // i >= 0 would add an unnecessary for final iteration where the first card swaps with itself, which serves no purpose
    // 0 <= random < 1
    // Time Complexity: O(n), Space Complexity: O(1)
    shuffle() {
        for(let i = this.numberOfCards - 1; i > 0; i--){
            const randomIndex = Math.floor(Math.random() * (i + 1));
            [this.cards[randomIndex], this.cards[i]] = [
                this.cards[i],
                this.cards[randomIndex]
            ];
        }
    }
}
// ----------⛔️⛔️⛔️
// CARD CLASS ----------✅✅✅
class $977499bb1a4cda90$var$Card {
    constructor(suit, value){
        this.suit = suit;
        this.value = value;
    }
    get color() {
        return this.suit === "\u2663" || this.suit === "\u2660" ? "black" : "red";
    }
    getHTML() {
        const cardDiv = document.createElement("div");
        cardDiv.innerText = this.suit;
        cardDiv.classList.add("card", this.color);
        cardDiv.dataset.value = `${this.value}`;
        return cardDiv;
    }
}
// ----------⛔️⛔️⛔️
// FRESH DECK FUNCTION ----------✅✅✅
function $977499bb1a4cda90$var$freshDeck() {
    return $977499bb1a4cda90$var$SUITS.flatMap((suit)=>{
        return $977499bb1a4cda90$var$VALUES.map((value)=>{
            return new $977499bb1a4cda90$var$Card(suit, value);
        });
    });
} // ----------⛔️⛔️⛔️


// ----------⛔️⛔️⛔️
// SELECTED THE ELEMENT ----------✅✅✅
const $c1ce9d969bfa6909$var$computerCardSlot = document.querySelector(".computer-card-slot");
const $c1ce9d969bfa6909$var$playerCardSlot = document.querySelector(".player-card-slot");
const $c1ce9d969bfa6909$var$computerDeckElement = document.querySelector(".computer-deck");
const $c1ce9d969bfa6909$var$playerDeckElement = document.querySelector(".player-deck");
const $c1ce9d969bfa6909$var$text = document.querySelector(".text");
const $c1ce9d969bfa6909$var$play = document.querySelector(".play");
const $c1ce9d969bfa6909$var$reset = document.querySelector(".reset");
// ----------⛔️⛔️⛔️
// GLOBAL VARIABLE ----------✅✅✅
const $c1ce9d969bfa6909$var$CARD_VALUE_MAP = {
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    10: 10,
    J: 11,
    Q: 12,
    K: 13,
    A: 14
};
let $c1ce9d969bfa6909$var$playerDeck, $c1ce9d969bfa6909$var$computerDeck, $c1ce9d969bfa6909$var$inRound, $c1ce9d969bfa6909$var$stop;
// ----------⛔️⛔️⛔️
// PLAY THE GAME ----------✅✅✅
$c1ce9d969bfa6909$var$play.addEventListener("click", function() {
    if ($c1ce9d969bfa6909$var$stop) {
        $c1ce9d969bfa6909$var$startGame();
        return;
    }
    if ($c1ce9d969bfa6909$var$inRound) $c1ce9d969bfa6909$var$cleanBeforeRound();
    else $c1ce9d969bfa6909$var$flipCards();
});
// ----------⛔️⛔️⛔️
// RESTART THE GAME ----------✅✅✅
$c1ce9d969bfa6909$var$reset.addEventListener("click", function() {
    $c1ce9d969bfa6909$var$resetGame();
});
// ----------⛔️⛔️⛔️
// START GAME FUNCTION ----------✅✅✅
$c1ce9d969bfa6909$var$startGame();
function $c1ce9d969bfa6909$var$startGame() {
    const deck = new (0, $977499bb1a4cda90$export$2e2bcd8739ae039)();
    deck.shuffle();
    // console.log(deck.cards);
    const deckMidpoint = Math.ceil(deck.numberOfCards / 2); // 52/2=26
    $c1ce9d969bfa6909$var$playerDeck = new (0, $977499bb1a4cda90$export$2e2bcd8739ae039)(deck.cards.slice(0, deckMidpoint));
    $c1ce9d969bfa6909$var$computerDeck = new (0, $977499bb1a4cda90$export$2e2bcd8739ae039)(deck.cards.slice(deckMidpoint, deck.numberOfCards));
    // console.log(playerDeck, computerDeck);
    $c1ce9d969bfa6909$var$inRound = false;
    $c1ce9d969bfa6909$var$stop = false;
    $c1ce9d969bfa6909$var$cleanBeforeRound();
}
// ----------⛔️⛔️⛔️
// CLEAN FUNCTION ----------✅✅✅
function $c1ce9d969bfa6909$var$cleanBeforeRound() {
    $c1ce9d969bfa6909$var$inRound = false;
    $c1ce9d969bfa6909$var$text.innerHTML = "";
    $c1ce9d969bfa6909$var$computerCardSlot.innerHTML = "";
    $c1ce9d969bfa6909$var$playerCardSlot.innerHTML = "";
    $c1ce9d969bfa6909$var$updateDeckCount();
}
// ----------⛔️⛔️⛔️
// FLIP CARDS FUNCTION ----------✅✅✅
function $c1ce9d969bfa6909$var$flipCards() {
    $c1ce9d969bfa6909$var$inRound = true;
    const playerCard = $c1ce9d969bfa6909$var$playerDeck.pop();
    const computerCard = $c1ce9d969bfa6909$var$computerDeck.pop();
    // render
    $c1ce9d969bfa6909$var$playerCardSlot.appendChild(playerCard.getHTML());
    $c1ce9d969bfa6909$var$computerCardSlot.appendChild(computerCard.getHTML());
    $c1ce9d969bfa6909$var$updateDeckCount();
    if ($c1ce9d969bfa6909$var$isRoundWinner(playerCard, computerCard)) {
        $c1ce9d969bfa6909$var$text.innerText = "You Win \uD83D\uDE07";
        $c1ce9d969bfa6909$var$playerDeck.push(playerCard);
        $c1ce9d969bfa6909$var$playerDeck.push(computerCard);
    } else if ($c1ce9d969bfa6909$var$isRoundWinner(computerCard, playerCard)) {
        $c1ce9d969bfa6909$var$text.innerText = "You Lose \uD83E\uDD7A";
        $c1ce9d969bfa6909$var$computerDeck.push(playerCard);
        $c1ce9d969bfa6909$var$computerDeck.push(computerCard);
    } else {
        $c1ce9d969bfa6909$var$text.innerText = "Draw \uD83D\uDE11";
        $c1ce9d969bfa6909$var$playerDeck.push(playerCard);
        $c1ce9d969bfa6909$var$computerDeck.push(computerCard);
    }
    if ($c1ce9d969bfa6909$var$isGameOver($c1ce9d969bfa6909$var$playerDeck)) {
        $c1ce9d969bfa6909$var$text.innerText = "You Lose! Try next time \uD83E\uDD7A";
        $c1ce9d969bfa6909$var$stop = true;
    } else if ($c1ce9d969bfa6909$var$isGameOver($c1ce9d969bfa6909$var$computerDeck)) {
        $c1ce9d969bfa6909$var$text.innerText = "You Win! Wanna try again? \uD83D\uDE04";
        $c1ce9d969bfa6909$var$stop = true;
    }
}
// ----------⛔️⛔️⛔️
// UPDATE-DECK COUNT FUNCTION ----------✅✅✅
function $c1ce9d969bfa6909$var$updateDeckCount() {
    $c1ce9d969bfa6909$var$computerDeckElement.innerHTML = $c1ce9d969bfa6909$var$computerDeck.numberOfCards;
    $c1ce9d969bfa6909$var$playerDeckElement.innerHTML = $c1ce9d969bfa6909$var$playerDeck.numberOfCards;
}
// ----------⛔️⛔️⛔️
// ROUND WINNER FUNCTION ----------✅✅✅
function $c1ce9d969bfa6909$var$isRoundWinner(cardOne, cardTwo) {
    return $c1ce9d969bfa6909$var$CARD_VALUE_MAP[cardOne.value] > $c1ce9d969bfa6909$var$CARD_VALUE_MAP[cardTwo.value];
}
// ----------⛔️⛔️⛔️
// GAME OVER FUNCTION ----------✅✅✅
function $c1ce9d969bfa6909$var$isGameOver(deck) {
    return deck.numberOfCards === 0;
}
// ----------⛔️⛔️⛔️
// RESET GAME FUNCTION ----------✅✅✅
function $c1ce9d969bfa6909$var$resetGame() {
    $c1ce9d969bfa6909$var$startGame();
    $c1ce9d969bfa6909$var$text.innerText = "";
} // ----------⛔️⛔️⛔️


//# sourceMappingURL=index.1801e240.js.map
